import apiClient from './client';
import { MAIN_API_PATH } from './constants';

export const mainGet = (params = {}, config = {}) => {
    return apiClient.get(MAIN_API_PATH, {
        params,
        ...config
    });
};

export const mainPost = (params = {}, data = {}, config = {}) => {
    return apiClient.post(MAIN_API_PATH, data, {
        params,
        ...config
    });
};
